import runActions from '../utils/api/runActions'

class RedirectButton {
  root

  constructor(root: any) {
    this.root = root
  }

  redirectButtonHandler = async () => {
    try {
      const { ProgressStore, StepsStore } = this.root
      const [result, firstErrorName] =
        ProgressStore.nextStepStatus(StepsStore.currentStep)
      console.log('result--->', result)
      StepsStore.firstErrorName = firstErrorName
      if (result) {
        const actions = StepsStore.stepsSetting[StepsStore.currentStep].actions || null
        if (actions) {
          StepsStore.isApiLoading = true
          const data = await runActions(
            StepsStore.stepsStoreApi,
            actions,
            StepsStore.values,
            StepsStore.stepsInputs[StepsStore.currentStep],
            StepsStore.lff_uid
          )
          //const data = await runActions(actions, this.values)
          console.log('data.status--->', data)
          if (data.status) {
            StepsStore.showSpinner = true

            this.handleRedirect()
          } else {

            StepsStore.apiErrors = {
              ...StepsStore.apiErrors,
              ...data.errors,
            }
            if (data.error) {
              StepsStore.apiErrors.error = data.error
            }
          }
          StepsStore.isApiLoading = false
        } else {
          this.handleRedirect()
        }
      } else {
        StepsStore.setNeedsToScroll(true)
      }
      //this.showSpinner = false
    } catch (error) { 
     console.log(error)
    }
  }

  handleRedirect = () => {
    console.log('redirect')
    const { StepsStore } = this.root
    StepsStore.stepsStoreConfig.finish({
      lff_uid: StepsStore.lff_uid,
      finish: StepsStore.stepsStoreApi.finish
    })
  }
}

export default RedirectButton